<template>
  <b-modal id="modal-confirm" size="xl">
    <!--Content-->
    <template slot="modal-header">
      <div class>
        <!--Header-->
        <div>{{ EntityTypeString }}</div>
      </div>
    </template>

    <!--Body-->
    <div class="modal-body">
      <SeminarReview review_type="Confirm" :seminar_object="current_seminar" />
    </div>

    <!--Footer-->
    <template slot="modal-footer">
      <div
        slot
        class="modal-footer justify-content-center"
        style="border: none"
      >
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="outline-primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-confirm')"
          aria-label="Close"
          >Cancel</b-button
        >
        <a
          type="button"
          class="btn btn-primary text-white"
          @click="transmitRequest"
        >
          Send
          <i class="fa fa-envelope ml-1 text-white"></i>
        </a>
      </div>
    </template>

    <!--/.Content-->
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SeminarReview from "@/components/CustomSubComponents/SeminarReview.vue";
export default {
  components: { SeminarReview },
  computed: {
    ...mapState(["n_user"]),
    ...mapActions("n_user", ["Delete"]),
    ...mapActions("dealership", ["Delete"]),
    ...mapActions("campaign", ["Delete"]),
  },
  data() {
    return {
      current_seminar: this.seminar_object,
      EntityTypeString: this.EntityType,
    };
  },
  created() {},
  mounted() {
  },
  methods: {
    transmitRequest: function () {
      this.$store
        .dispatch("seminar/Notify", {
          seminar: {SeminarID: this.current_seminar.SeminarID},
          type: 1,
        })
        .then(this.$bvModal.hide("modal-confirm"));
    },
  },
  props: {
    seminar_object: { type: Object },
    EntityType: "",
  },
  updated() {},
};
</script>
